module.exports = __webpack_public_path__ + "img/logo_big.4b81cd94.png";